export const blockIconsTextformattingBorderColorNew = (
	<span className='material-symbols-outlined'>border_color</span>
);
